import type { ReactNode } from "react";
import { useI18n } from "../i18n";
import { healthLabel, type Health } from "./model";

export function Badge({ state }: { state: Health }) {
  const { t } = useI18n();
  return (
    <span className={`monitor-badge monitor-${state}`}>
      {healthLabel(state, t)}
    </span>
  );
}
export function Note({ children }: { children: ReactNode }) {
  return (
    <p className="monitor-note" role="status">
      {children}
    </p>
  );
}
export function Summary({
  items,
}: {
  items: Array<{ label: string; value: string; note?: string }>;
}) {
  return (
    <dl className="monitor-summary">
      {items.map((item) => (
        <div key={item.label}>
          <dt>{item.label}</dt>
          <dd>{item.value}</dd>
          {item.note ? <small>{item.note}</small> : null}
        </div>
      ))}
    </dl>
  );
}
export function Empty({ children }: { children: ReactNode }) {
  return (
    <div className="monitor-empty" role="status">
      {children}
    </div>
  );
}
export function Table({
  headers,
  children,
}: {
  headers: string[];
  children: ReactNode;
}) {
  return (
    <div className="administrator-table-wrap">
      <table className="administrator-table monitor-table">
        <thead>
          <tr>
            {headers.map((h) => (
              <th key={h}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}
